/**
 * Helpers
 */
import EA from './helpers/init';
import UserAgent from './helpers/userAgent';

/* body class */
UserAgent.setBodyClass();

/**
 * Methods
 */
import './methods/exampleMethod.js';
import './methods/heroLoadAnim.js';
import './methods/headerLoadAnim.js';
import './methods/imageLazyLoad.js';
import './methods/videoLazyLoad.js';
import './methods/mobileMenuHandler.js';
import './methods/animFadeUp.js';
import './methods/locomotiveScrollInit.js';
import './methods/heroSlider.js';
import './methods/heroHistorySlider.js';
import './methods/gallerySlider.js';
import './methods/lightGallery.js';
import './methods/accordionHandler.js';
import './methods/openPositionsHandler.js';
import './methods/formHandler.js';

import { createApp } from 'vue';
import { defineAsyncComponent } from 'vue';

const app = createApp({
    mounted() {
        EA.loadMethods();
        EA.Methods.locomotiveScrollInit();
    }
});

/* Components */
app.component('ExampleComponent', defineAsyncComponent(() => import('../../components/ExampleComponent.vue')));

/* Add Pinia store */
// import { createPinia } from 'pinia';
// const pinia = createPinia();
// app.use(pinia);

app.mount('#app');
